import React, { useContext } from 'react';

import Alert from '@react/react-spectrum/Alert';
import Wait from '@react/react-spectrum/Wait';

import { Header } from '../../fragments/Header';
import { useSidebar, useNavbar } from './hooks';
import { RootContext } from '../../root/RootContext';
import { FeaturesContext } from '../../features/FeaturesContext';
import { useCurrentUser } from '../../data/hooks';
import A from '../../services/analytics';
import { getAuthRedirectUrl } from '../../services/environment';

import './App.scss';

export default function App({ children }) {
  const { loading, error, data } = useCurrentUser();
  const rootContext = useContext(RootContext);
  const featuresContext = useContext(FeaturesContext);

  const { sidebar } = useSidebar();
  const { navbar } = useNavbar();

  if (loading) {
    return (
      <div className="app-wrapper">
        <div className="wait-wrapper">
          <Wait centered size="L" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="app-wrapper">
        <div className="error-wrapper">
          <ErrorHandler error={error} />
        </div>
      </div>
    );
  }

  if (data && data.me && data.me.id && !A.getUser()) {
    // Force login for anonymous user
    if (data.me.id === 'anonymous') {
      window.location = getAuthRedirectUrl();
    } else {
      A.setUser(data.me.id);
      A.triggerToolStart();
    }
  }

  let myImsOrgs = [...(data.myIMSOrgs || [])];
  myImsOrgs.sort((a, b) => a.name.localeCompare(b.name));

  // TODO: at next refactor, this should be moved to a setState/reducer action, not set directly
  rootContext.state.currentUser = data.me;
  rootContext.state.myImsOrgs = myImsOrgs;
  rootContext.state.configurations = data.configurations;

  featuresContext.state.enabledFeatures = data.features;

  return (
    <div className="app-wrapper">
      <Header currentUser={data.me} />
      <div className="app-content">
        <nav className={navbar.isOpen ? 'is-open' : ''}>
          {navbar.isOpen && navbar.content}
        </nav>
        <main>{children}</main>
        <aside className={sidebar.isOpen ? 'is-open' : ''}>
          {sidebar.isOpen && sidebar.content}
        </aside>
      </div>
    </div>
  );
}

function ErrorHandler({ error }) {
  if (error.error?.networkError?.statusCode === 401) {
    return (
      <Alert variant="info" header="Welcome">
        We need to sign you in first. Redirecting...
      </Alert>
    );
  } else if (
    error.networkError?.statusCode === 404 ||
    error.error?.networkError?.statusCode === 404 ||
    error.error?.message === 'Failed to fetch'
  ) {
    return (
      <Alert variant="info" header="Just a moment, please">
        We're updating our backend, please try again in a minute.
        <br />
        If you keep seeing this message, let us know at{' '}
        <a href="mailto:demosystem@adobe.com">demosystem@adobe.com</a>.
      </Alert>
    );
  } else {
    return (
      <Alert variant="error" header="Error">
        {error.message}
      </Alert>
    );
  }
}
